import { deepClone } from "../helpers/object";
import { type Category } from "../interfaces/category";

export const topLevelCategoryNames = [
  "Appliances",  
  "Computers & Accessories",   
  "Electronics",
  "Phones & Tablets",
  "Fashion", 
  "Sports",
  "Gaming",
  "Baby Products", 
  "Building Materials",   
  "Garden & Outdoors", 
  "Health & Beauty", 
  "Home & Office", 
  "Industrial & Scientific", 
  "Musical Instruments",  
  "Supermarket", 
  "Other Categories"
];

export function buildCategoryStringForApiCall(categoryObject: Category) {
  let category = deepClone(categoryObject);
  const categoryNames: string[] = [];

  function buildCategoryWithChildrenNameArray(category: Category) {
    const names: string[] = [category.name];

    if(category.children) {
      for(let i = 0; i < category.children.length; i++) {
        const child = category.children[i];
        names.push(child.name);
        
        if(child.children) {
          names.push(...(buildCategoryWithChildrenNameArray(child)));
        }
      }
    }
    
    return names;
  }

  if(category.children) {
    // If a category that has gone through the parseCategories() function
    // the category will have a children array.
    categoryNames.push(...(buildCategoryWithChildrenNameArray(category)));
  } else { 
    while(category) {
      categoryNames.push(category.name);
      category = category.parent;
    }
  }

  return categoryNames.map(name => name.toLowerCase()).join(";");
}

interface ParsedCategoriesReturnValue { 
  topLevelCategories: Category[];
  secondLevelCategories?: Category[];
  thirdLevelCategories?: Category[]; 
};
export function parseCategories(categories: Category[]): ParsedCategoriesReturnValue {
  const childCategories  = categories.filter(category => Boolean(category.parent));
  const parentCategories = (categories 
    .filter(category => !(category.parent))
    .map(category => populateWithChildren(category, childCategories)));

  const topLevelCategories = parentCategories.sort((a, b) => a.name.localeCompare(b.name));
  /* Uncomment these lines if we need to use second- and third-level categories
  const topLevelCategoryNames = getCategoryNames(topLevelCategories);
  const secondLevelCategories = (parentCategories
    .filter(category => !(topLevelCategoryNames.includes(category.name))) 
    .sort((a, b) => a.name.localeCompare(b.name))
  );

  const secondLevelCategoryNames = getCategoryNames(secondLevelCategories);
  const thirdLevelCategories = (categories
    .filter(category => !(secondLevelCategoryNames.includes(category.name)))
    .sort((a, b) => a.name.localeCompare(b.name))
  );
  */

  return {
    topLevelCategories, 
    //secondLevelCategories, 
    //thirdLevelCategories,
    //parentCategories, // Every category that has a child, whether the category is top level or second level.
    //childCategories,  // Every child category, whether or not the child category itself has its own children.
  };
}

/*function getCategoryNames(categories: Category[]): string[] {
  return categories.map(category => category.name);
}*/

// Helper function to find the top-level parent name
/*function getTopLevelParent(category: Category) {
  let parent = category.parent;

  while(parent && parent.parent) {
    parent = parent.parent;
  }

  return parent;
}*/

function populateWithChildren(category: Category, childCategories: Category[]) {
  return {
    ...category,
    children: childCategories
      .filter(cc => cc.parent?.id === category.id)
      .map(child => populateWithChildren(child, childCategories))
      .sort((a, b) => a.name.localeCompare(b.name))
  };
}
